import styled from "styled-components";

export const Words = styled.div`
  & p {
    line-height: 20px;
  }
`;
